<template>
    <div class="folder-steps">
        <a-steps
            :current="currentStep"
        >
            <a-step v-for="step in steps" :key="step.title" :title="step.title" />
        </a-steps>
        <div class="steps-content"
            v-if="currentStep === 0"
        >
            <div class="steps-main">
                <FolderForm 
                    :folderType="folderType"
                    :formData="formData"
                    v-on:valuesChange="handleValuesChange"
                />
            </div>
            <a-divider></a-divider>
            <div class="steps-actions">
                <a-button
                    v-on:click="step1Forward"
                >
                    Tovább
                    <a-icon type="right" />
                </a-button>
            </div>       
        </div>
        <div class="steps-content"
            v-if="currentStep === 1"
        >   
            <a-spin
                :spinning="folderCreateLoading"
            >
                <div
                    :style="{
                        margin: 'auto',
                        maxWidth: '800px'
                    }"
                >
                    <h1
                        :style="{
                            textAlign: 'center'
                        }"
                    >
                        Összegzés
                    </h1>
                    <div class="akta-card-holder">
                        <InfoResult 
                            v-if="folderType === 'info'"
                            :folderObj="editedAktaObj"
                            :forceDetailed="true"
                        />
                        <AktaResult 
                            v-else
                            :folderObj="editedAktaObj"
                            :forceDetailed="true"
                        />
                    </div>
                    <a-divider>
                    </a-divider>
                    <a-button
                        v-on:click="stepBackward"
                    >
                        <a-icon type="left" />
                        Vissza
                    </a-button>
                    <a-button
                        type="primary"
                        v-on:click="finalClick"
                    >
                        Tovább
                    </a-button>
                </div>
            </a-spin>
        </div>

        
    </div>
    
</template>

<script>
import TagsSearchSelectWrapper from '@/components/app/search_components/TagsSearchSelectWrapper.vue';
import MaskedSlideTransition from '@/transitions/MaskedSlideTransition.vue';
import SearchSlider from '@/components/app/search_components/SearchSlider.vue';
import FolderForm from './FolderForm.vue';
import AktaResult from '@/components/app/akta_components/AktaResult.vue';
import InfoResult from '@/components/app/info_components/InfoResult.vue';
import moment from 'moment';
import uuidv4 from 'uuid/v4';
import { createFolder } from '../../../http/api';
import { defaultFolderObj } from '../../../helpers/defaultProps';

export default {
    components: {
        MaskedSlideTransition,
        TagsSearchSelectWrapper,
        SearchSlider,
        FolderForm,
        InfoResult,
        AktaResult
    },

    props: {
        folderId: String,
        folderType: {
            type: String,
            default: 'info'
        }
    },

    data() {
        return {
            currentStep: 0,
            steps: [
                {
                    title: `${this.folderType} adatlap`,
                    icon: 'folder'
                },
                {
                    title: 'Összefoglalás',
                    icon: 'upload'
                }
            ],
            folderCreateLoading: false,
            
            formData: {
                ...defaultFolderObj()
            }
        }
    },

    computed: {
        selectedTags() {
            return this.editedTags.filter(tag => tag.checked === true);
        },
        editedAktaObj() {
            return {
                ...this.formData
            }
        }
    },

    methods: {
        stepForward() {
            this.currentStep += 1;
        },

        stepBackward() {
            this.currentStep -= 1;
        },

        handleValuesChange(changedValues) {
            this.formData = {
                ...this.formData,
                ...changedValues
            }
        },
        step1Forward() {
            this.stepForward();
        },

        finalClick() {
            this.folderCreateLoading = true;
            const folderOptions = {
                ...this.formData,
            };
            const folder = {
                name: folderOptions.name,
                isInfo: this.folderType === 'info' ? true : false,
                description: folderOptions.description,
                isEmphasized: folderOptions.isEmphasized,
                priority: folderOptions.priority,
                tags: folderOptions.tags.map(el => el.id),
                persons: folderOptions.persons.map(el => el.id),
                topics: folderOptions.topics.map(el => el.id),
                overall: this.folderType === 'akta' ? folderOptions.overall : ''
            }

            createFolder(folder).then(res => {
                console.log('FOLDER_CREATED', res);
                this.folderCreateLoading = false;
                const routeName = this.folderType === 'info' ? 'infos' : 'aktas'
                this.$router.push({
                    name: routeName
                })
            })
        }

    }
}
</script>

<style lang="scss">
    .folder-steps {
        .ant-steps-item-title {
            text-transform: capitalize;
        }
        .primary-blue-bg {
            border-color: $primary-blue;
        }
        .steps-content {
            margin-top: 25px;
            
        }
        .steps-main {
            min-height: 300px;
        }
        .akta-card-holder {
            display: flex;
        }
    }
    
</style>
